/* Start Section drmlec_zive_28feb_wwai_before_after_2_bWT7TB */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .swiper',{loop:false,slidesPerView:1,spaceBetween:36,grabCursor:false,centeredSlides:1,initialSlide:0,roundLengths:true,speed:1500,navigation:{nextEl:'.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .next',prevEl:'.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .prev',clickable:true},pagination:{el:".dots",clickable:true},breakpoints:{500:{slidesPerView:2,centeredSlides:false,loop:false,initialSlide:0},768:{slidesPerView:3,centeredSlides:false,loop:false,initialSlide:0}},on:{init:function(){toggleNavigationButtons(this);},slideChange:function(){toggleNavigationButtons(this);},resize:function(){toggleNavigationButtons(this);}}});function toggleNavigationButtons(swiperInstance){const nextButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .next');const prevButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .prev');const totalSlides=swiperInstance.slides.length;const slidesPerView=swiperInstance.params.slidesPerView;if(totalSlides<=slidesPerView){nextButton.style.display='none';prevButton.style.display='none';}else{nextButton.style.display=null;prevButton.style.display=null;}}});
/* End Section drmlec_zive_28feb_wwai_before_after_2_bWT7TB */
/* Start Section product_section_drm_v_2_nmBYVF */
document.addEventListener('DOMContentLoaded',function(){function closeModal(){const togglBtn=document.querySelector('[data-toggl="model"]');if(!togglBtn){console.warn("No toggle button found with data-toggl='model'");return;}
const modelContainer=document.querySelector(`[data-id="${togglBtn.dataset.toggl}"]`);if(!modelContainer){console.warn(`No modal container found with data-id="${togglBtn.dataset.toggl}"`);return;}
modelContainer.style.display='none';console.log("Modal closed.");}
document.querySelectorAll('[data-modal-link-update]').forEach(link=>{link.addEventListener('click',function(event){closeModal();});});});function manageQtyBtn(event){event.preventDefault();let currentTarget=event.currentTarget;let action=currentTarget.dataset.for||'increase';let qtyContainer=currentTarget.closest('[data-qty-container]');let qtyInput=qtyContainer.querySelector('[data-qty-input]');let currentQty=parseInt(qtyInput.value)||1;let finalQty=currentQty;let decreaseQtyBtn=qtyContainer.querySelector('[data-for="decrease"]');if(action==='decrease'&&currentQty>1){finalQty=currentQty-1;}else if(action==='increase'){finalQty=currentQty+1;}
qtyInput.value=finalQty;if(finalQty<=1){decreaseQtyBtn.classList.add('disabled');}else{decreaseQtyBtn.classList.remove('disabled');}}
const qtyBtns=document.querySelectorAll('[data-qty-btn]');qtyBtns.forEach(qtyBtn=>{qtyBtn.addEventListener('click',manageQtyBtn);});const inputBtns=document.querySelectorAll('[data-input-change]');inputBtns.forEach(inputBtn=>{inputBtn.addEventListener('change',()=>{const closestElement=inputBtn.closest('[data-closest-input]');document.querySelectorAll('[data-closest-input]').forEach(closest=>{closest.classList.remove('active-input');});if(closestElement){if(inputBtn.checked){closestElement.classList.add('active-input');}}});});document.addEventListener('DOMContentLoaded',function(){let thumbnailSlider=new Swiper('.section-template--product_section_drm_v_2_nmBYVF .product-thumbnail',{direction:'horizontal',slidesPerView:4,spaceBetween:10,grabCursor:true,loop:false,slideToClickedSlide:true,watchSlidesVisibility:true,watchSlidesProgress:true,breakpoints:{768:{slidesPerView:5,direction:'vertical',spaceBetween:13,},},});let carouselSlider=new Swiper('.section-template--product_section_drm_v_2_nmBYVF .product-carousel',{shortSwipes:true,resizeObserver:true,observer:true,observeParents:true,loop:false,slidesPerView:1,grabCursor:true,pagination:{el:'.section-template--product_section_drm_v_2_nmBYVF .product-carousel .swiper-pagination',clickable:true,},thumbs:{swiper:thumbnailSlider,},on:{init:function(){const carouselWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-carousel');const thumbnailWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-thumbnail');if(carouselWrapper&&thumbnailWrapper){thumbnailWrapper.style.maxHeight=`${carouselWrapper.offsetHeight}px`;}},resize:function(){const carouselWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-carousel');const thumbnailWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-thumbnail');if(carouselWrapper&&thumbnailWrapper){thumbnailWrapper.style.maxHeight=`${carouselWrapper.offsetHeight}px`;}},}});document.addEventListener('swipetoSlide',function(event){let index=event.detail.index;if(carouselSlider&&typeof index==='number'){carouselSlider.slideTo(index);}});})
document.addEventListener('DOMContentLoaded',function(){const togglBtn=document.querySelector('[data-toggl="model"]');const modelContainer=document.querySelector(`[data-id="${togglBtn.dataset.toggl}"]`);cosst=modleOverlay=modelContainer.querySelector('.overlay');cosst=modleClose=modelContainer.querySelector('.model_close-btn');modleOverlay?.addEventListener('click',(e)=>{modelContainer.style.display='none';});modleClose?.addEventListener('click',(e)=>{modelContainer.style.display='none';});togglBtn?.addEventListener('click',(e)=>{modelContainer.style.display='block';});});
/* End Section product_section_drm_v_2_nmBYVF */
/* Start Section drmlec_zive_28feb_wwai_review_carousel_LxUQyg */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .swiper',{loop:false,slidesPerView:1,spaceBetween:36,grabCursor:false,centeredSlides:1,initialSlide:0,roundLengths:true,speed:1500,navigation:{nextEl:'.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .next',prevEl:'.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .prev',clickable:true},pagination:{el:".dots",clickable:true},breakpoints:{500:{slidesPerView:2,centeredSlides:false,loop:false,initialSlide:0},768:{slidesPerView:3,centeredSlides:false,loop:false,initialSlide:0}},on:{init:function(){toggleNavigationButtons(this);},slideChange:function(){toggleNavigationButtons(this);},resize:function(){toggleNavigationButtons(this);}}});function toggleNavigationButtons(swiperInstance){const nextButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .next');const prevButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .prev');const totalSlides=swiperInstance.slides.length;const slidesPerView=swiperInstance.params.slidesPerView;if(totalSlides<=slidesPerView){nextButton.style.display='none';prevButton.style.display='none';}else{nextButton.style.display=null;prevButton.style.display=null;}}});
/* End Section drmlec_zive_28feb_wwai_review_carousel_LxUQyg */
/* Start Section video_section_drm_v_2_PtM77C */
document.addEventListener('DOMContentLoaded',function(){var Swipes;function initSwiper(){if(window.innerWidth>768){if(!Swipes){Swipes=new Swiper('.section-template--video_section_drm_v_2_PtM77C .swiper',{loop:false,slidesPerView:1,spaceBetween:15,grabCursor:false,centeredSlides:true,initialSlide:0,roundLengths:true,speed:1500,breakpoints:{768:{slidesPerView:3,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:30},1199:{slidesPerView:4,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:30}}});Swipes.on('slideChange',function(){document.querySelectorAll('.section-template--video_section_drm_v_2_PtM77C video-player').forEach(video=>{video.classList.remove('played');video.querySelectorAll('video').forEach(ele=>{ele.pause();})});});}}else{if(Swipes){Swipes.destroy(true,true);Swipes=null;}}}
initSwiper();window.addEventListener('resize',function(){initSwiper();});});document.querySelectorAll('.section-template--video_section_drm_v_2_PtM77C video-player').forEach(video=>{video.addEventListener('click',function(){document.querySelectorAll('.section-template--video_section_drm_v_2_PtM77C video-player').forEach(ele=>{if(video!=ele){ele.classList.remove('played');ele.querySelectorAll('video').forEach(ele=>{ele.pause();});}});});});
/* End Section video_section_drm_v_2_PtM77C */
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
// class VideoPlayer extends HTMLElement {
//   constructor() {
//     super();
//     this.videos = this.querySelectorAll('video');
//     this.videoWeb = this.videos[0];
//     this.videoMob = this.videos[1];
//     this.playBtn = this.querySelector('.play-btn');
//     this.soundBtn = this.querySelector('.mute-btn');
//     this.disableClick = this.dataset.click;
//     if (this.disableClick) {
//       this.initEventListeners();
//     }
//   }

//   initEventListeners() {
//     this.videos.forEach(video => {
//       video.addEventListener('click', () => this.togglePlay(video));
//       video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
//     });

//     if (this.playBtn) {
//       this.playBtn.addEventListener('click', () => this.handlePlayButton());
//     }

//     if (this.soundBtn) {
//       this.soundBtn.addEventListener('click', () => this.toggleMute());
//     }

//     window.addEventListener('resize', () => this.handleResize());
//   }

//   togglePlay(video) {
//     if (video.paused) {
//       this.playVideo(video);
//     } else {
//       this.pauseVideo(video);
//     }
//   }

//   playVideo(video) {
//     this.videos.forEach(otherVideo => {
//       if (otherVideo !== video) otherVideo.pause();
//     });
//     video.play();
//     this.classList.add('played');
//   }

//   pauseVideo(video) {
//     video.pause();
//     this.classList.remove('played');
//   }

//   handlePlayButton() {
//     const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
//     if (targetVideo) this.togglePlay(targetVideo);
//   }

//   toggleMute() {
//     const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
//     if (targetVideo) {
//       targetVideo.muted = !targetVideo.muted;
//       this.soundBtn.classList.toggle('active', targetVideo.muted);
//     }
//   }

//   handleResize() {
//     if (!this.videoMob) return;

//     const isMobile = window.innerWidth < 749;
//     const targetVideo = isMobile ? this.videoMob : this.videoWeb;

//     this.videos.forEach(video => video.pause());
//     targetVideo.play();
//     targetVideo.pause(); // Ensure the video is ready for user interaction
//   }

//   handleVideoEnded(video) {
//     // Check if the video is not set to loop
//     if (!video.loop) {
//       this.classList.remove('played');
//     }
//   }
// }

// customElements.define('video-player', VideoPlayer);

(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) otherVideo.pause();
        });
        video.play();
        this.classList.add('played');
      }

      pauseVideo(video) {
        video.pause();
        this.classList.remove('played');
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => video.pause());
        targetVideo.play();
        targetVideo.pause(); // Ensure the video is ready for user interaction
      }

      handleVideoEnded(video) {
        // Check if the video is not set to loop
        if (!video.loop) {
          this.classList.remove('played');
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();

if (!customElements.get('carousel-slider')) {
class CarouselSlider extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cacheElements();
    this.bindEvents();
    this.scrollToMediaItem(this.activeIndex);
  }

  cacheElements() {
    this.mainMedia = this.querySelector('main-slider');
    this.thumbSlider = this.querySelector('thumb-slider');
    this.thumbVertical = this.thumbSlider?.dataset.vartical;
    this.pagenation = this.querySelector('pagenation');
    this.mediaItems = this.mainMedia?.querySelectorAll('main-slider-slide') || [];
    this.thumbItems = this.thumbSlider?.querySelectorAll('thumb-slider-slide') || [];
    this.pageItems = this.pagenation?.querySelectorAll('button.page-media-item') || [];
  }

  bindEvents() {
    const mediaBtnNext = this.querySelector('.media-next');
    const mediaBtnPrev = this.querySelector('.media-prev');

    mediaBtnNext?.addEventListener('click', () => this.goToNext());
    mediaBtnPrev?.addEventListener('click', () => this.goToPrev());

    this.thumbItems.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.scrollToMediaItem(index));
    });
    
    this.pageItems.forEach((page, index) => {
      page.addEventListener('click', () => this.scrollToMediaItem(index));
    });
    
    let scrollTimeout = null;
    this.mainMedia?.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.handleScrollSnap(), 200);
    });
    
    const updateThumbSliderHeight = () => {
      if (this.thumbVertical && window.innerWidth > 768) {
        this.thumbSlider.style.maxHeight = this.mainMedia.offsetHeight + 'px';
      } else {
        this.thumbSlider.style.maxHeight = ''; // Optional: reset height on small screens
      }
    };
  
    setTimeout(updateThumbSliderHeight, 200);
  
    window.addEventListener('resize', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateThumbSliderHeight, 200);
    });
  }

  handleScrollSnap() {
    const scrollLeft = this.mainMedia.scrollLeft;
    const itemWidth = this.mediaItems[0]?.clientWidth || 0;
    const offset = scrollLeft + this.mainMedia.offsetLeft;

    let closestIndex = 0;
    let minDiff = Infinity;
    this.mediaItems.forEach((item, i) => {
      const diff = Math.abs(item.offsetLeft - offset);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = i;
      }
    });

    this.scrollToMediaItem(closestIndex);
  }

  goToNext() {
    if (this.activeIndex < this.mediaItems.length - 1) {
      this.scrollToMediaItem(this.activeIndex + 1);
    }
  }

  goToPrev() {
    if (this.activeIndex > 0) {
      this.scrollToMediaItem(this.activeIndex - 1);
    }
  }

  scrollToMediaItem(index) {
    if (!this.mediaItems.length) return;

    this.mediaItems[this.activeIndex]?.classList.remove('active');
    this.thumbItems[this.activeIndex]?.classList.remove('active');
    this.pageItems[this.activeIndex]?.classList.remove('active');

    this.activeIndex = index;

    this.mediaItems[this.activeIndex]?.classList.add('active');
    this.thumbItems[this.activeIndex]?.classList.add('active');
    this.pageItems[this.activeIndex]?.classList.add('active');

    const scrollLeft = this.mediaItems[this.activeIndex].offsetLeft - this.mainMedia.offsetLeft;
    this.mainMedia.scrollTo({ left: scrollLeft, behavior: 'smooth' });

    const thumbScroll = this.thumbItems[this.activeIndex].offsetLeft - this.thumbSlider.offsetLeft - ((this.thumbSlider.clientWidth / 2) - (this.thumbItems[this.activeIndex].clientHeight / 2));
    this.thumbSlider.scrollTo({ left: thumbScroll, behavior: 'smooth' });
  }

  refresh(index = 0) {
    this.activeIndex = index;
    this.cacheElements();
    this.bindEvents();
  }

  createCustomCarouselSlide(data, isThumbnail = false) {
    const slideTag = isThumbnail ? 'thumb-slider-slide' : 'main-slider-slide';
    const slideClass = isThumbnail ? 'thumb-media-item' : 'main-media-item';
    const slide = document.createElement(slideTag);
    slide.className = slideClass;
    slide.id = isThumbnail ? undefined : `wwai-media-${data.id}`;

    const img = document.createElement('img');
    img.src = isThumbnail ? `${data.src}&width=${data.width}` : data.src;
    img.alt = data.alt || "Image";
    img.width = data.width;
    img.height = data.height;
    img.loading = 'lazy';
    img.className = isThumbnail ? 'thumb-media-img' : 'main-media-img';

    const srcset = isThumbnail
      ? `${data.src}&width=${data.width} ${data.width}w`
      : [
          `${data.src}&width=352 352w`,
          `${data.src}&width=832 832w`,
          `${data.src}&width=1200 1200w`,
          `${data.src}&width=1920 1920w`,
          `${data.src}&width=2561 2561w`
        ].join(', ');

    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', '(min-width: 1536px) 1500px,(min-width: 1280px) 1250px,(min-width: 768px) 994px,(min-width: 768px) 708px,(min-width: 640px) 610px,100vw');

    if (isThumbnail) {
      slide.setAttribute('data-handle', `media-${data.id}`);
      slide.setAttribute('data-img-id', data.src);
    }

    slide.appendChild(img);
    return slide;
  }

  gotoSlide(index) {
    if (!this.mediaItems.length) return;

    if (index < 0) {
      const resolvedIndex = this.mediaItems.length + index;
      this.scrollToMediaItem(resolvedIndex);
    } else {
      this.scrollToMediaItem(index);
    }
  }

  clearSlides() {
    this.mainMedia.innerHTML = '';
    this.thumbSlider.innerHTML = '';
    this.mediaItems = [];
    this.thumbItems = [];
    this.activeIndex = 0;
  }
}

customElements.define('carousel-slider', CarouselSlider);
}